module.exports = __webpack_public_path__ + "media/pl_pl_s3_Szymon.3c034697.mp3";